import axios from "axios";
import Config from "src/config";

const v1_actionCriarFigurinha = (formData) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chats/canais/figurinhas`,
        data: formData,
    });
};

export default v1_actionCriarFigurinha;
